import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-other-pages',
  templateUrl: './other-pages.component.html',
  styleUrls: ['./other-pages.component.css']
})
export class OtherPagesComponent implements OnInit {
  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;
  public env = environment;
  public id: any = '';
  public tabs: any[] = ['about_us', 'privacy_policy', 'terms_and_conditions', 'responsible_gaming', '18_plus', 'kyc']
  public isIn: boolean = false;

  constructor(public router: Router, private actRoute: ActivatedRoute) { 
    document.body.classList.add('hide-sidebar');
  }

  ngOnInit(): void {
    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.selectTab(this.tabs.indexOf(this.id));
  }

  rout() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this.id != this.actRoute.snapshot.paramMap.get('id')) {
          this.id = this.actRoute.snapshot.paramMap.get('id');
          this.selectTab(this.tabs.indexOf(this.id));
        }
      }
    })
  }

  selectTab(tabId: number) {
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }

  onSelect(key: string): void {
    this.router.navigate([`/pages`, key]);
  }

  ngAfterContentChecked() {    
    if (this.id && this.staticTabs && this.isIn == false) {
      this.selectTab(this.tabs.indexOf(this.id));
      this.isIn = true;
    }
  }

}
